// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"1ccd64d5","203":"1ccd64d5","331":"2dee05a6","820":"148c3941"}[chunkId] + ".chunk.css";
};